export default {
    switchHeader: {},
    transitionContainer: {},
    iconButton: {},
    daysHeader: {},
    dayLabel: {},
};
